import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {FlexColumnCentered} from "../../../../components/ui/Content";
import {FormTitle, RecoveryEmailInfo} from "../../../../components/Font";
import {
    ButtonContainer,
    ErrorSpan,
    InputSpan,
    RecoveryInputContainer,
    RegisterInputContainer
} from "../../../../components/ui/InputSearch";
import PhoneInput, {isValidPhoneNumber} from "react-phone-number-input";
import {InputPhone} from "../../../../ui/Input/InputPhone";
import ru from "react-phone-number-input/locale/ru.json";
import {setChangeDataModal, setChangeDataModalSuccess} from "../api/slice";
import {setChangeDataForChangeNull, SetNewPhone, setChangeSuccessFalse} from '../UserInfo/slice';
import { addErrorEnter, cleanErrorEnter} from "../UserInfo/slice";

import {ButtonDefault, ButtonPrimary} from "../../../../components/ui/Button";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../ui/Loader/MiniLoader";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";

export const ForeignPhoneForm = () => {

    const { isFetching,error,setChangeSuccess } = useAppSelector(state => state.user)

    const dispatch = useAppDispatch()
    const {t} = useTranslation();
    const [phone, setPhone] = useState('')
    const [phoneConfirm, setPhoneConfirm] = useState('')
    const [phoneError, setPhoneError] = useState(false)
    const [phoneConfirmError, setPhoneConfirmError] = useState(false)
    const Theme = useTheme()

    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
    }

    const phoneSubmit = () => {
        if(phoneError || phoneConfirmError){
            if (phoneError) {
                dispatch(addErrorEnter({key: 'phone', value: t('auth.enterValidPhone')}))
            }

            if (phoneConfirmError) {
                dispatch(addErrorEnter({key: 'phone_confirm', value: t('auth.enterValidPhone')}))
            }
            return
        }

        if (phone !== phoneConfirm) {
            dispatch(addErrorEnter({key: 'phone_confirm', value: t('auth.phonesDontMatch')}))
            dispatch(cleanErrorEnter('phone'))
            return;
        }
        dispatch(SetNewPhone(
            {
                phone: phone,
                phone_confirm: phoneConfirm
            }
        ))
    }

    useEffect(() => {
        setChangeSuccess && dispatch(setChangeDataModalSuccess(true))
    }, [setChangeSuccess])

    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <FormTitle>Введите новый номер</FormTitle>
            <RecoveryEmailInfo style={{textAlign: 'center', width: '270px'}}>
                Ваш номер телефона будет использоваться для входа в аккаунт
            </RecoveryEmailInfo>
        </FlexColumnCentered>
        <RegisterInputContainer style={{marginTop: 28}}>
            <RecoveryInputContainer style={{border: error['phone'] ? '1px solid red':''}}>
                <PhoneInput
                    id={'registerPhoneInput'}
                    className={'PhoneInput'}
                    countrySelectComponent={InputPhone}
                    countrySelectProps={{unicodeFlags: true}}
                    error={error['phone']}
                    international
                    countryCallingCodeEditable={false}
                    limitMaxLength={true}
                    labels={ru}
                    defaultCountry="RU"
                    value={phone}
                    onChange={value => {
                        if (error['phone'] || error['phone_confirm']) {
                            dispatch(cleanErrorEnter('phone'))
                            dispatch(cleanErrorEnter('phone_confirm'))
                        }

                        if (value) {
                            setPhoneError(!isValidPhoneNumber(value))
                            setPhone(value.toString())
                        }
                        else {
                            setPhone('')
                        }
                    }}
                    onKeyDown={(e:React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                            phoneSubmit()
                        }
                    }}
                />
                <InputSpan>
                    Номер телефона
                </InputSpan>
            </RecoveryInputContainer>
            {error['phone'] && <ErrorSpan>
                {error['phone']}
            </ErrorSpan>}
        </RegisterInputContainer>
        <RegisterInputContainer style={{marginTop: 16}}>
            <RecoveryInputContainer style={{border: error['phone_confirm'] ? '1px solid red':''}}>
                <PhoneInput
                    id={'registerPhoneConfirmInput'}
                    className={'PhoneInput'}
                    countrySelectComponent={InputPhone}
                    countrySelectProps={{unicodeFlags: true}}
                    error={error['phone_confirm']}
                    international
                    countryCallingCodeEditable={false}
                    limitMaxLength={true}
                    labels={ru}
                    defaultCountry="RU"
                    value={phoneConfirm}
                    onChange={value => {
                        if (error['phone'] || error['phone_confirm']) {
                            dispatch(cleanErrorEnter('phone'))
                            dispatch(cleanErrorEnter('phone_confirm'))
                        }
                        if (value) {
                            setPhoneConfirmError(!isValidPhoneNumber(value))
                            setPhoneConfirm(value.toString())
                        }
                        else {
                            setPhoneConfirm('')
                        }
                    }}
                    onKeyDown={(e:React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                            phoneSubmit()
                        }
                    }}
                />
                <InputSpan>
                    Подтвердите номер
                </InputSpan>
            </RecoveryInputContainer>
        </RegisterInputContainer>
        {error['phone_confirm'] && <ErrorSpan>
            {error['phone_confirm']}
        </ErrorSpan>}
        <ButtonContainer style={{marginTop: '34px'}}>
            <ButtonDefault style={{width: '165px'}}
                           onClick={()=>{
                               closeModal();
                               dispatch(cleanErrorEnter('phone'))
                               dispatch(cleanErrorEnter('phone_confirm'));
                           }
                           }
            >Отмена</ButtonDefault>
            {isFetching
                ? <ButtonPrimary style={{
                    width: '165px',
                    marginLeft: '20px'

                }} disabled={isFetching}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={phone.length < 12 || phoneConfirm.length < 12}
                    onClick={phoneSubmit}
                    style={{
                        width: '165px',
                        marginLeft: '20px'
                    }}>
                    {t('auth.continue')}
                </ButtonPrimary>}
        </ButtonContainer>
    </>
}